function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 20,
  r: 15,
  fill: "currentColor"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21 18.4792L25.1382 14.3422C25.2367 14.2366 25.3554 14.1518 25.4872 14.0931C25.6191 14.0343 25.7615 14.0027 25.9059 14.0002C26.0502 13.9976 26.1936 14.0242 26.3275 14.0783C26.4614 14.1323 26.583 14.2128 26.6851 14.3149C26.7872 14.417 26.8677 14.5386 26.9217 14.6725C26.9758 14.8064 27.0024 14.9498 26.9998 15.0941C26.9973 15.2385 26.9657 15.3809 26.9069 15.5128C26.8482 15.6446 26.7634 15.7633 26.6578 15.8618L22.5208 20L26.6578 24.1382C26.7634 24.2367 26.8482 24.3554 26.9069 24.4872C26.9657 24.6191 26.9973 24.7615 26.9998 24.9059C27.0024 25.0502 26.9758 25.1936 26.9217 25.3275C26.8677 25.4614 26.7872 25.583 26.6851 25.6851C26.583 25.7872 26.4614 25.8677 26.3275 25.9217C26.1936 25.9758 26.0502 26.0024 25.9059 25.9998C25.7615 25.9973 25.6191 25.9657 25.4872 25.9069C25.3554 25.8482 25.2367 25.7634 25.1382 25.6578L21 21.5208L16.8618 25.6578C16.7633 25.7634 16.6446 25.8482 16.5128 25.9069C16.3809 25.9657 16.2385 25.9973 16.0941 25.9998C15.9498 26.0024 15.8064 25.9758 15.6725 25.9217C15.5386 25.8677 15.417 25.7872 15.3149 25.6851C15.2128 25.583 15.1323 25.4614 15.0783 25.3275C15.0242 25.1936 14.9976 25.0502 15.0002 24.9059C15.0027 24.7615 15.0343 24.6191 15.0931 24.4872C15.1518 24.3554 15.2366 24.2367 15.3422 24.1382L19.4792 20L15.3422 15.8618C15.1523 15.658 15.0489 15.3884 15.0538 15.1098C15.0587 14.8313 15.1716 14.5655 15.3685 14.3685C15.5655 14.1716 15.8313 14.0587 16.1098 14.0538C16.3884 14.0489 16.658 14.1523 16.8618 14.3422L21 18.4792Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 42,
  height: 42,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 11.1316,
  y1: 7.93233,
  x2: 29.4023,
  y2: 32.2932,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF7A63"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5C41"
})));

var SvgTimerResetBtn = function SvgTimerResetBtn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimerResetBtn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timer-reset-btn.36cee5d0.svg";
export { ForwardRef as ReactComponent };